export var logoutAuth = {
    user: undefined,
    signedIn: false,
    token: undefined,
    marketplaceId: undefined,
    addressId: undefined,
    timeZone: undefined,
    marketplaces: [],
    version: undefined,
};
